import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import DrawerDialog from '../../../utils/utilities/DrawerDialog';

import BasicSideDrawer from '../../../utils/utilities/SideDrawer';

import SearchInput from '../../../utils/utilities/SearchInput';

// icons
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded';
import ArrowBack from '@mui/icons-material/ArrowBack';

import { Button, Tooltip, Divider, IconButton } from '@mui/material';

import { ScrollableContainer, BasicFlex } from '../../../utils/Common';

// tickets
import KanbanTicket from './KanbanTicket';

const InputContainer = styled.div`
  max-height: min-content;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  /* padding: 1rem; */
`;

const TicketList = styled(ScrollableContainer)`
  border-radius: 8px;
  padding: 1rem .5rem;
  background-color: ${props => props.theme.colors.darkBg};
  min-height: 80vh;
  max-height: 80vh;
  margin-top: 1rem;
`

const SelectedTicket = styled.div`

`;

const BackButton = styled.div`
  margin: 1rem 0;
`


const mockTickets = [
  { service_ticket_id: 1, wig_id: "12345", service_name: "Wash & Set", client_name: "John Doe", status: "prepping", current_station: "Washing Area", checked_in_at: "2024-12-25T14:45:00.000+00:00", prep_stages: [{station: "Washing Area", received_at: "2024-12-25T14:45:00.000+00:00", completed_at: null, status: "pending"}, {station: "Cutting Station", received_at: null, completed_at: null, status: "pending"}] },
  {
    service_ticket_id: 2, wig_id: "MK5432", service_name: "Wash & Set", client_name: "John Doe", status: "prepping", current_station: "Cutting Station", checked_in_at: "2024-12-25T14:45:00.000+00:00", prep_stages: [{station: "Washing Area", received_at: "2024-12-25T14:45:00.000+00:00", completed_at: "2024-12-25T16:55:00.000+00:00", status: "completed"}, {station: "Cutting Station", received_at: "2024-12-26T10:55:00.000+00:00", completed_at: null, status: "pending"}]
  }
]


const SideDrawer = ({ sideBar, handleClose }) => {
  const [ticket, setTicket] = useState(null);

  let in_house = sideBar.category ? true : false
  let title = in_house ? `Receive Ticket to ${sideBar.category} Station` : `Receive Ticket to ${sideBar.vendor}`;

  return (
    <BasicSideDrawer open={sideBar.open} title={title} handleClose={handleClose}>
      <InputContainer>
        <SearchInput fieldsToSearch={[ "Customer", "Wig ID", "Ticket ID"]} />
        <Divider>
          <span>OR</span>
        </Divider>
        <Tooltip title="Scan QR Code"><Button variant="outlined" color="primary" startIcon={<QrCodeScannerRoundedIcon />} sx={{minWidth: "unset"}}>Scan Wig QR Code</Button></Tooltip>
        {/* <Divider orientation="vertical" flexItem sx={{mx: 1}} />
        <Tooltip title="Close"><IconButton onClick={() => handleClose(false)} size="small"><CloseIcon /></IconButton></Tooltip> */}
      </InputContainer>
      {ticket ? <BackButton><Button startIcon={<ArrowBack />} onClick={() => setTicket(null)} color="secondary" sx={{width: "fit-content"}}>Back</Button></BackButton> : null}
      {!ticket ? <TicketList>
        <BasicFlex dir="column" width="100%" gap="1rem">
          {mockTickets.map((ticket, index) => (<KanbanTicket key={index} ticket={ticket} receive={true} onClick={() => setTicket(ticket)} />))}
        </BasicFlex>
      </TicketList> : <SelectedTicket><KanbanTicket ticket={ticket} receive={true} onClick={() => setTicket(null)} expanded={true} /></SelectedTicket>}
    </BasicSideDrawer>
  )
};

export default SideDrawer;